// import {reUrl} from '../../axiosconfig/axiosconfig'
function getCookie(name) {
    const cookies = document.cookie.split(';');
    
    for (let cookie of cookies) {
        const [cookieName, cookieValue] = cookie.trim().split('=');
        if (cookieName === name) {
            return decodeURIComponent(cookieValue);
        }
    }
    
    return undefined;
}

// todo test
export const auth = {
    // server: 'http://127.0.0.1:88',
    server: '',
    get username() {
        return getCookie('username')
    },
    get salt() {
        return getCookie('salt')
    },
    get hash() {
        return getCookie('hash')
    }
}
